// extracted by mini-css-extract-plugin
module.exports = {"desktopNavIcon":"style-module--desktopNavIcon--PuUBD"};